import { render, staticRenderFns } from "./PoliceImportTicket.vue?vue&type=template&id=b5b4d070&scoped=true&"
import script from "./PoliceImportTicket.vue?vue&type=script&lang=js&"
export * from "./PoliceImportTicket.vue?vue&type=script&lang=js&"
import style0 from "./PoliceImportTicket.vue?vue&type=style&index=0&id=b5b4d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4d070",
  null
  
)

export default component.exports